/**
 * @desc 向数据中台暴露同步数据接口
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialDataRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/material/add',
    data,
  });
}

export function mock(
  data: defs.MaterialDataRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/material/add',
    data,
  });
}
